document.addEventListener("DOMContentLoaded", function () {
  console.log("Hello from the WPCT Child Theme");
});
